import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import logo from "../Images/footer-logo.png";

function Footer() {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-start">
          <Col lg={4} md={6} className="footer-col footer-brand-col mb-4">
            <img className="footer-logo" src={logo} alt="Haveli Restaurant" />
            <p className="footer-tagline">
              Lahore&apos;s premier heritage dining destination — where Mughal grandeur meets unforgettable hospitality.
            </p>
          </Col>
          <Col lg={2} md={6} sm={6} className="footer-col mb-4">
            <h4>Explore</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/menu">Menu</Link></li>
              <li><Link to="/gellary">Gallery</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </Col>
          <Col lg={3} md={6} sm={6} className="footer-col mb-4">
            <h4>Experiences</h4>
            <ul>
              <li><Link to="/dining-experience">Dining Areas</Link></li>
              <li><Link to="/club">Haveli Club</Link></li>
              <li><Link to="/catering">Events &amp; Buffet</Link></li>
              <li><Link to="/citytours">Walled City Tours</Link></li>
            </ul>
          </Col>
          <Col lg={3} md={6} className="footer-col mb-4">
            <h4>Contact</h4>
            <ul className="footer-contact-list">
              <li>
                <FaMapMarkerAlt aria-hidden />
                <span>Food Street, Fort Road, Walled City, Lahore</span>
              </li>
              <li>
                <FaEnvelope aria-hidden />
                <a href="mailto:info@haveli.com.pk">info@haveli.com.pk</a>
              </li>
              <li>
                <FaPhoneAlt aria-hidden />
                <a href="tel:+923008414899">+92 300 841 4899</a>
              </li>
              <li>
                <FaPhoneAlt aria-hidden />
                <a href="tel:+923214651051">+92 321 465 1051</a>
              </li>
            </ul>
            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
            </div>
          </Col>
        </Row>
      </Container>
      <div className="footer-bottom">
        © {new Date().getFullYear()} Haveli Restaurant, Lahore — All Rights Reserved
      </div>
    </footer>
  );
}

export default Footer;
